import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchHouseBillsThunk = createAsyncThunk(
  "houseBills/fetch",
  async (home_id, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/api/houses-bills/${home_id}`);
      if (!data?.status) return rejectWithValue(data?.message || "Failed");
      return data.data;
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

const houseBillsSlice = createSlice({
  name: "houseBills",
  initialState: {
    water: [],
    slrm: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearHouseBillsError: (s) => {
      s.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchHouseBillsThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchHouseBillsThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.water = a.payload.water || [];
      s.slrm = a.payload.slrm || [];
    });
    b.addCase(fetchHouseBillsThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearHouseBillsError } = houseBillsSlice.actions;
export default houseBillsSlice.reducer;
